import { render, staticRenderFns } from "./AddFishModal.vue?vue&type=template&id=f7bb424c&"
import script from "./AddFishModal.vue?vue&type=script&lang=js&"
export * from "./AddFishModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFishModal.vue?vue&type=style&index=0&id=f7bb424c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports